export default __webpack_public_path__ + "static/media/share.7700c31f.svg";